import { Button } from 'app/agriculture/components/Button/Button';
import classNames from 'classnames';
import { ComponentProps } from 'react';

import './SecondaryNavSubNav.scss';

interface SecondaryNavSubNavProps {
    items: ComponentProps<typeof Button>[];
}

export function SecondaryNavSubNav({ items }: SecondaryNavSubNavProps) {
    if (items.length === 0) {
        return null;
    }

    return (
        <div className="SecondaryNavSubNav">
            {items.map((item) => {
                return (
                    <Button
                        {...item}
                        variant="textonly"
                        className={classNames('SecondaryNavSubNav__item', item.className)}
                    />
                );
            })}
        </div>
    );
}
